// AUTOGENERATED FILE
// source: scripts/generate-product-types-templates.ts

import React from 'react'
import { ReactComponent as TemplateSVG } from '../../../../../assets/product-templates/svg/rigid-box-template.svg'

export const RigidBoxTemplate = (props: React.SVGProps<SVGSVGElement>) => {
  return <TemplateSVG {...props} />
}
